var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React from 'react';
import AnnouncerContext from './AnnouncerContext';
import AnnouncerMessage from './AnnouncerMessage';

var LiveMessage = function LiveMessage(props) {
  return React.createElement(AnnouncerContext.Consumer, null, function (contextProps) {
    return React.createElement(AnnouncerMessage, _extends({}, contextProps, props));
  });
};

export default LiveMessage;